import styled from 'styled-components';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

export const NotFound = styled(Box)`
  ${({ theme: { colors } }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 45px;
    padding: 65px 0;
    border-top: 2px solid ${colors.greys.greys3};
  `}
`;

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
`;

export const Title = styled(Typography)`
  text-align: center;
  margin-bottom: 10px;
`;

export const Description = styled(Typography)`
  text-align: center;
  max-width: 355px;
  opacity: 0.75;
`;
